import { Component, ViewEncapsulation, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Role } from '../../../shared/models/Role/Role';
import { RolesService } from '../roles.service';
import { AppService } from '../../../app.service';
import { ListPageBase } from '../../../shared/components/list-page-base/list-page-base';
import { DataSourceRequestState } from '@progress/kendo-data-query';
import { fromEvent } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { StatePersistingService } from '../../../shared/services/state-persisting.service';
import { ExportExcelFromGridService } from '../../../shared/services/export-excel-from-grid.service';
import { GridSettings } from '../../../shared/models/grid/grid-settings';

@Component({
	selector: 'admin-roles',
	templateUrl: './list.page.html',
	styleUrls: ['./list.page.scss'],
})
export class RolesListPage extends ListPageBase<Role> {

	constructor(
		appService: AppService,
		router: Router,
		protected dataService: RolesService,
		protected persistingService: StatePersistingService,
		protected exportExcelFromGridService: ExportExcelFromGridService) {
		super(router, appService, dataService, persistingService, exportExcelFromGridService);
		appService.pageTitle = 'Роли';
	}

	public gridSettingsFilter: GridSettings = {
		state: {
			skip: 0,
			take: 100,
			sort: [{ field: 'createdDate', dir: 'desc' }],
			filter: { logic: 'and', filters: [] }
		},
		columnsConfig: [
			{
				orderIndex: 1,
				field: 'name',
				title: 'Наименование',
				filter: 'string',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'description',
				title: 'Описание',
				filter: 'string',
				filterable: true,
				width: 250,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'isAdmin',
				title: 'Администратор',
				filter: 'boolean',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 4,
				field: 'createdDate',
				title: 'Дата создания',
				filter: 'date',
				filterable: true,
				width: 350,
				hidden: false,
				format: 'dd.MM.yyyy HH:mm'
			},
			{
				orderIndex: 5,
				field: 'discountLimit',
				title: 'Максимальный размер скидки',
				filter: 'numeric',
				filterable: true,
				width: 250,
				hidden: true
			},
			{
				orderIndex: 6,
				field: 'forceDiscount',
				title: 'Произвольная скидка',
				filter: 'boolean',
				filterable: true,
				width: 200,
				hidden: true
			},
		]
	}

	public gridSettings: GridSettings = {
		state: {
			skip: 0,
			take: 100,
			sort: [{ field: 'createdDate', dir: 'desc' }],
			filter: { logic: 'and', filters: [] }
		},
		columnsConfig: [
			{
				orderIndex: 1,
				field: 'name',
				title: 'Наименование',
				filter: 'string',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 2,
				field: 'description',
				title: 'Описание',
				filter: 'string',
				filterable: true,
				width: 250,
				hidden: false
			},
			{
				orderIndex: 3,
				field: 'isAdmin',
				title: 'Администратор',
				filter: 'boolean',
				filterable: true,
				width: 180,
				hidden: false
			},
			{
				orderIndex: 4,
				field: 'createdDate',
				title: 'Дата создания',
				filter: 'date',
				filterable: true,
				width: 180,
				hidden: false,
				format: 'dd.MM.yyyy HH:mm'
			},
			{
				orderIndex: 5,
				field: 'discountLimit',
				title: 'Максимальный размер скидки',
				filter: 'numeric',
				filterable: true,
				width: 250,
				hidden: true
			},
			{
				orderIndex: 6,
				field: 'forceDiscount',
				title: 'Произвольная скидка',
				filter: 'boolean',
				filterable: true,
				width: 200,
				hidden: true
			},
		]
	}

	onListPageInit(): void { }

	processListItems(items: Role[]): void { }

	public cellClick({ dataItem }: any): void {
		this.router.navigate(['/admin/role', dataItem.roleId]);
	}

	public onFilter(inputValue: string): void {

		var customState: DataSourceRequestState = {
			skip: 0,
			take: this.gridSettings.state.take,
			sort: this.gridSettings.state.sort,
			filter: {
				logic: "or",
				filters: [
					{
						field: 'name',
						operator: 'contains',
						value: inputValue
					}
				],
			}
		};
		
		this.loadData(customState);
    }
}
